import * as types from '../mutations-types'

import {createActionHelpers} from 'vuex-loading'

import {
  fetchUnreportedEventsAlarms,
  fetchMovementAlarms,
  justificationGeneralAlarm,
  justificationAlarm,
  fetchSpeedAlarms,
  fetchMissionAlarms,
  fetchParkingAlarms,
  fetchGeofenceInAlarms,
  fetchVehicleWithoutEvents3hAlarms
} from '../../utils/api'

import {genericAlarms, missionsAlarms} from '../../utils/genericAlarms'

// import Vue from 'vue'

const {startLoading} = createActionHelpers({
  moduleName: 'loading'
})

const state = {
  unreportedAlarms: [],
  loadingUnreportedEventsAlarms: true,
  loadingMovementAlarms: true,
  movementAlarms: [],
  missionAlarms: [],
  speedsAlarms: [],
  loadingSpeedAlarms: true,
  loadingMissionAlarms: true,
  showAutoReloadAlarm: false,
  showReloadAlarmsMessage: false,
  missionAlertsIntervalInstance: null,
  currentJustificationsInProgress: [],
  intervalValueMissioAlarms: 120000,
  loadingParkingAlarms: true,
  parkingAlarms: [],
  loadingGeofenceInAlarms: true,
  geofenceInAlarms: [],
  loadingVehicleWithoutEvents3hAlarms: true,
  vehicleWithoutEvents3hAlarms: []
}

const getters = {
  unreportedAlarms: state => state.unreportedAlarms,
  loadingUnreportedEventsAlarms: state => state.loadingUnreportedEventsAlarms,
  loadingMovementAlarms: state => state.loadingMovementAlarms,
  movementAlarms: state => state.movementAlarms,
  loadingMissionAlarms: state => state.loadingMissionAlarms,
  missionAlarms: state => state.missionAlarms,
  speedsAlarms: state => state.speedsAlarms,
  loadingSpeedAlarms: state => state.loadingSpeedAlarms,
  showAutoReloadAlarm: state => state.showAutoReloadAlarm,
  showReloadAlarmsMessage: state => state.showReloadAlarmsMessage,
  missionAlertsIntervalInstance: state => state.missionAlertsIntervalInstance,
  currentJustificationsInProgress: state => state.currentJustificationsInProgress,
  intervalValueMissioAlarms: state => state.intervalValueMissioAlarms,
  loadingParkingAlarms: state => state.loadingParkingAlarms,
  parkingAlarms: state => state.parkingAlarms,
  loadingGeofenceInAlarms: state => state.loadingGeofenceInAlarms,
  geofenceInAlarms: state => state.geofenceInAlarms,
  loadingVehicleWithoutEvents3hAlarms: state => state.loadingVehicleWithoutEvents3hAlarms,
  vehicleWithoutEvents3hAlarms: state => state.vehicleWithoutEvents3hAlarms
}

const actions = {
  clearUnreportedEventsAlarms({commit}) {
    commit(types.CLEAR_UNREPORTED_EVENT_ALARMS)
  },
  updateJustificationUnreportedEventAlarm({commit}, data) {
    commit(types.UPDATE_UNREPORTED_EVENT_ALARMS, data)
  },
  setLoadingUnreportedEventsAlarms({commit}, value) {
    commit(types.SET_LOADING_UNREPORTED_EVENTS_ALARMS, value)
  },
  async fetchUnreportedEventsAlarms({commit, dispatch}) {
    await startLoading(dispatch, 'fetchUnreportedEventsAlarms', () => {
      return fetchUnreportedEventsAlarms()
    })
      .then(data => {
        commit(types.SET_LOADING_UNREPORTED_EVENTS_ALARMS, false)
        commit(types.FETCH_UNREPORTED_EVENTS_ALARMS, data.data)

        // Verify if a alarm or alarms are in current justification
        dispatch('checkCurrentJustificationsInProgress')
      })
      .catch(error => {
        commit(types.SET_LOADING_UNREPORTED_EVENTS_ALARMS, false)
        if (error.hasOwnProperty('response')) {
          console.error('WRA', error.response)
          // if (error.response.status === 401) dispatch('auth/logout')
        } else console.error('FWRA', error)
      })
  },
  updateJustificationMovementAlarm({commit}, data) {
    commit(types.UPDATE_MOVEMENT_ALARMS, data)
  },
  async fetchMovementAlarms({commit, dispatch, getters}) {
    await startLoading(dispatch, 'fetchMovementAlarms', () => {
      return fetchMovementAlarms()
    })
      .then(data => {
        // console.log('FETCH_MOVEMENT_ALARMS: ', data.data)
        const alarms = data.data
        const vehicles = getters.lastPositionsInit
        const allowedAlarms = []
        for (let index = 0; index < alarms.length; index++) {
          const element = alarms[index]

          // Verify if the data in contrast with the current vehicles of the session
          for (let i = 0; i < vehicles.length; i++) {
            const vehicle = vehicles[i]
            const match = element.device === vehicle.deviceId
            if (match) allowedAlarms.push(element)
          }
        }
        commit(types.SET_LOADING_MOVEMENT_ALARMS, false)
        commit(types.FETCH_MOVEMENT_ALARMS, allowedAlarms)

        // Verify if a alarm or alarms are in current justification
        dispatch('checkCurrentJustificationsInProgress')
      })
      .catch(error => {
        commit(types.SET_LOADING_MOVEMENT_ALARMS, false)
        if (error.hasOwnProperty('response')) {
          console.error('FMA', error.response)
          // if (error.response.status === 401) dispatch('auth/logout')
        } else console.error('FMA', error)
      })
  },
  clearMovementAlarms({commit}) {
    commit(types.CLEAR_MOVEMENT_ALARMS)
  },
  setLoadingMovementAlarms({commit}, value) {
    commit(types.SET_LOADING_MOVEMENT_ALARMS, value)
  },
  setLoadingSpeedAlarms({commit}, value) {
    commit(types.SET_LOADING_SPEED_ALARMS, value)
  },
  setLoadingMissionAlarms({commit}, value) {
    commit(types.SET_LOADING_MISSION_ALARMS, value)
  },
  clearMissionAlarms({commit}) {
    commit(types.CLEAR_MISSION_ALARMS)
  },
  clearSpeedsAlarms({commit}) {
    commit(types.CLEAR_SPEEDS_ALARMS)
  },
  updateJustificationSpeedAlarm({commit}, data) {
    commit(types.UPDATE_SPEED_ALARMS, data)
  },
  justificationGeneralAlarm({dispatch}, data) {
    return new Promise(async(resolve, reject) => {
      try {
        const response = await startLoading(dispatch, 'justificationAlarm', () => {
          return justificationGeneralAlarm(data)
        })
        if (response.data.success) {
          // console.log('DATA JGA', response, data)
          resolve(response)
        }
      } catch (error) {
        console.error('ERROR JGA', error)
        resolve(error.response)
      }
    })
  },
  justificationInProgress({commit}, data) {
    // console.log('JUSTIFICATION IN PROGRESS', data)
    commit(types.SET_JUSTIFICATION_IN_PROGRESS, data.data)
    commit(types.SET_CURRENT_JUSTIFICATIONS_IN_PROGRESS, data.data)
  },
  updateJustificationMissionAlarm({commit, getters, dispatch}, data) {
    const currentUser = getters['auth/getProfile'].name
    if (currentUser === data.u) {
      // console.log('SAME USER', data.u)
      dispatch('setShowAutoReloadAlarm', true)
      clearInterval(getters.missionAlertsIntervalInstance)
      dispatch('clearMissionAlarms')
      dispatch('setMissionAlertsIntervalInstance', null)
      dispatch('setLoadingMissionAlarms', true)
      dispatch('fetchMissionAlarms')
      // Set Interval
      const intervalInstance = setInterval(() => {
        dispatch('fetchMissionAlarms')
      }, getters.intervalValueMissioAlarms)
      dispatch('setMissionAlertsIntervalInstance', intervalInstance)
    } else {
      // console.log('DIFFERENT USER', data.u)
      dispatch('setShowReloadAlarmsMessage', true)
      commit(types.UPDATE_MISSION_ALARMS, data)
    }
  },
  justificationAlarm({commit, dispatch}, data) {
    return new Promise(async(resolve, reject) => {
      try {
        const response = await startLoading(dispatch, 'justificationAlarm', () => {
          return justificationAlarm(data)
        })
        if (response.data.success) {
          resolve(response)
        }
      } catch (error) {
        console.error('ERROR JA', error)
        resolve(error.response)
      }
    })
  },
  async fetchMissionAlarms({commit, dispatch}) {
    await startLoading(dispatch, 'fetcheMissionAlarms', () => {
      return fetchMissionAlarms()
    })
      .then(data => {
        // console.log('MISSIONS ALARMS DATA:', data.data)
        commit(types.SET_LOADING_MISSION_ALARMS, false)
        commit(types.FETCH_MISSION_ALARMS, data.data)

        // Verify if a alarm or alarms are in current justification
        dispatch('checkCurrentJustificationsInProgress')
      })
      .catch(error => {
        commit(types.SET_LOADING_MISSION_ALARMS, false)
        if (error.hasOwnProperty('response')) {
          console.error('FMA', error.response)
          // if (error.response.status === 401) dispatch('auth/logout')
        // } else console.log('FMA', error)
        }
      })
  },
  async fetchSpeedAlarms({commit, dispatch, getters}) {
    // commit(types.SET_LOADING_SPEED_ALARMS, true)
    await startLoading(dispatch, 'fetchSpeedAlarms', () => {
      return fetchSpeedAlarms()
    })
      .then(data => {
        // console.log('FETCH_SPEED_ALARMS: ', data.data)
        const alarms = data.data
        const vehicles = getters.lastPositionsInit
        const allowedAlarms = []
        for (let index = 0; index < alarms.length; index++) {
          const element = alarms[index]

          // Verify if the data in contrast with the current vehicles of the session
          for (let i = 0; i < vehicles.length; i++) {
            const vehicle = vehicles[i]
            const match = element.device === vehicle.deviceId
            if (match) allowedAlarms.push(element)
          }
        }
        commit(types.SET_LOADING_SPEED_ALARMS, false)
        commit(types.FETCH_SPEED_ALARMS, allowedAlarms)

        // Verify if a alarm or alarms are in current justification
        dispatch('checkCurrentJustificationsInProgress')
      })
      .catch(error => {
        commit(types.SET_LOADING_SPEED_ALARMS, false)
        if (error.hasOwnProperty('response')) {
          console.error('SPA', error.response)
          // if (error.response.status === 401) dispatch('auth/logout')
        } else console.error('FSPA', error)
      })
  },
  setShowAutoReloadAlarm({commit}, value) {
    commit(types.SET_SHOW_AUTO_RELOAD_ALARM, value)
  },
  setShowReloadAlarmsMessage({commit}, value) {
    commit(types.SET_SHOW_RELOAD_ALARMS_MESSAGE, value)
  },
  setMissionAlertsIntervalInstance({commit}, value) {
    commit(types.SET_MISSION_ALERT_INTERVAL_INSTANCE, value)
  },
  setCurrentJustificationsInProgress({commit}, payload) {
    commit(types.SET_CURRENT_JUSTIFICATIONS_IN_PROGRESS, payload.data)
  },
  checkCurrentJustificationsInProgress({commit, getters}) {
    // Verify if a alarm or alarms are in current justification
    getters.currentJustificationsInProgress.forEach(element => {
      commit(types.SET_JUSTIFICATION_IN_PROGRESS, element)
    })
  },
  setLoadingParkingAlarms({commit}, value) {
    commit(types.SET_LOADING_PARKING_ALARMS, value)
  },
  async fetchParkingAlarms({commit, getters, dispatch}) {
    await startLoading(dispatch, 'fetchingParkingAlarms', () => {
      return fetchParkingAlarms()
    })
      .then(data => {
        const alarms = data.data
        const vehicles = getters.lastPositionsInit
        const allowedAlarms = []
        for (let index = 0; index < alarms.length; index++) {
          const element = alarms[index]

          // Verify if the data in contrast with the current vehicles of the session
          for (let i = 0; i < vehicles.length; i++) {
            const vehicle = vehicles[i]
            const match = element.device === vehicle.deviceId
            if (match) allowedAlarms.push(element)
          }
        }
        commit(types.SET_LOADING_PARKING_ALARMS, false)
        commit(types.FETCH_PARKING_ALARMS, allowedAlarms)

        // Verify if a alarm or alarms are in current justification
        dispatch('checkCurrentJustificationsInProgress')
      })
      .catch(error => {
        commit(types.SET_LOADING_PARKING_ALARMS, false)
        if (error.hasOwnProperty('response')) {
          console.error('FPA', error.response)
          // if (error.response.status === 401) dispatch('auth/logout')
        } else console.error('FPA', error)
      })
  },
  updateJustificationParkingAlarm({commit}, data) {
    commit(types.UPDATE_PARKING_ALARMS, data)
  },
  clearParkingAlarms({commit}) {
    commit(types.CLEAR_PARKING_ALARMS)
  },
  setLoadingGeofenceInAlarms({commit}, value) {
    commit(types.SET_LOADING_GEOFENCE_IN_ALARMS, value)
  },
  async fetchGeofenceInAlarms({commit, dispatch}) {
    await startLoading(dispatch, 'fetchingGeofenceInAlarms', () => {
      return fetchGeofenceInAlarms()
    })
      .then(data => {
        // console.log('GEOFENCE IN ALARM DATA:', data.data)
        commit(types.SET_LOADING_GEOFENCE_IN_ALARMS, false)
        commit(types.FETCH_GEOFENCE_IN_ALARMS, data.data)

        // Verify if a alarm or alarms are in current justification
        // dispatch('checkCurrentJustificationsInProgress')
      })
      .catch(error => {
        commit(types.SET_LOADING_GEOFENCE_IN_ALARMS, false)
        if (error.hasOwnProperty('response')) {
          console.error('FGIA', error.response)
        }
      })
  },
  updateJustificationGeofenceInEventAlarm({commit}, data) {
    commit(types.UPDATE_GEOFENCE_IN_EVENT_ALARMS, data)
  },
  clearGeofenceInAlarms({commit}, data) {
    commit(types.CLEAR_GEOFENCE_IN_ALARMS)
  },
  setLoadingVehicleWithoutEvents3hAlarms({commit}, value) {
    commit(types.SET_LOADING_VEHICLES_WITHOUT_EVENTS_3H_ALARMS, value)
  },
  async fetchVehicleWithoutEvents3hAlarms({commit, dispatch, getters}) {
    await startLoading(dispatch, 'fetchingfetchVehicleWithoutEvents3hAlarms', () => {
      return fetchVehicleWithoutEvents3hAlarms()
    })
      .then(data => {
        const alarms = data.data
        commit(types.SET_LOADING_VEHICLES_WITHOUT_EVENTS_3H_ALARMS, false)
        commit(types.FETCH_VEHICLES_WITHOUT_EVENTS_3H_ALARMS, alarms)
      })
      .catch(error => {
        commit(types.SET_LOADING_VEHICLES_WITHOUT_EVENTS_3H_ALARMS, false)
        if (error.hasOwnProperty('response')) {
          console.error('FVWE3HA', error.response)
          // if (error.response.status === 401) dispatch('auth/logout')
        } else console.error('FVWE3HA', error)
      })
  },
  clearVehicleWithoutEvents3hAlarms({commit}) {
    commit(types.CLEAR_VEHICLES_WITHOUT_EVENTS_3H_ALARMS)
  }
}

const mutations = {
  [types.CLEAR_UNREPORTED_EVENT_ALARMS](state) {
    state.unreportedAlarms = []
  },
  [types.UPDATE_UNREPORTED_EVENT_ALARMS](state, payload) {
    const alarmIndex = state.unreportedAlarms.findIndex(item => item.alarmId === payload.i)
    if (alarmIndex !== -1) {
      state.unreportedAlarms[alarmIndex].justification.isJustified = payload.j
      state.unreportedAlarms[alarmIndex].justification.observations = payload.o
    }
  },
  [types.SET_LOADING_UNREPORTED_EVENTS_ALARMS](state, value) {
    state.loadingUnreportedEventsAlarms = value
  },
  [types.FETCH_UNREPORTED_EVENTS_ALARMS](state, data) {
    // Sort for the alarms
    const alarmSort = data.sort(function(a, b) {
      const textA = a.initialDate
      const textB = b.initialDate
      return (textA > textB) ? -1 : (textA < textB) ? 1 : 0
    })
    // Sort for stoppedVehicles
    alarmSort.forEach(element => {
      const event = element.stoppedVehicles
      const eventFromSort = event.sort(function(a, b) {
        const textA = a.time
        const textB = b.time
        return (textA > textB) ? -1 : (textA < textB) ? 1 : 0
      })
      element.event = eventFromSort
    })
    state.unreportedAlarms = alarmSort
  },
  [types.UPDATE_MOVEMENT_ALARMS](state, payload) {
    const alarmIndex = state.movementAlarms.findIndex(item => item.alarmId === payload.i)
    if (alarmIndex !== -1) {
      state.movementAlarms[alarmIndex].justification.isJustified = payload.j
      state.movementAlarms[alarmIndex].justification.observations = payload.o
    }
  },
  [types.FETCH_MOVEMENT_ALARMS](state, data) {
    state.movementAlarms = data
  },
  [types.CLEAR_MOVEMENT_ALARMS](state) {
    state.movementAlarms = []
  },
  [types.SET_LOADING_MOVEMENT_ALARMS](state, value) {
    state.loadingMovementAlarms = value
  },
  [types.CLEAR_MISSION_ALARMS](state) {
    state.missionAlarms = []
  },
  [types.CLEAR_SPEEDS_ALARMS](state) {
    state.speedsAlarms = []
  },
  [types.UPDATE_SPEED_ALARMS](state, payload) {
    const alarmIndex = state.speedsAlarms.findIndex(item => item.alarmId === payload.i)
    if (alarmIndex !== -1) {
      state.speedsAlarms[alarmIndex].justification.isJustified = payload.j
      state.speedsAlarms[alarmIndex].justification.observations = payload.o
    }
  },
  [types.SET_JUSTIFICATION_IN_PROGRESS](state, payload) {
    // console.log('SET_JUSTIFICATION_IN_PROGRESS IN', payload, state.missionAlarms)

    if (payload.t === 'mission' || payload.t === 'geofenceIn') {
      const missionType = missionsAlarms.get(payload.t)
      const missionIndex = state[missionType].findIndex(item => item.name === payload.a)
      // console.log(missionIndex)
      if (missionIndex !== -1) {
        for (let index1 = 0; index1 < state[missionType][missionIndex].vehicles.length; index1++) {
          const vehicle = state[missionType][missionIndex].vehicles[index1]
          if (vehicle.alarmId === payload.i) {
            state[missionType][missionIndex].vehicles[index1].justificationInProgress = payload.v
            state[missionType][missionIndex].vehicles[index1].userInProgressRemote = payload.u
            break
          }
        }
      }
    } else {
      const missionType = genericAlarms.get(payload.t)
      if (missionType !== undefined) {
        const missionIndex = state[missionType].findIndex(item => item.alarmId === payload.i)
        // console.log(missionIndex, missionType)
        if (missionIndex !== -1) {
          state[missionType][missionIndex].justification.justificationInProgress = payload.v
          state[missionType][missionIndex].justification.userInProgressRemote = payload.u
        }
      }
    }
  },
  [types.UPDATE_MISSION_ALARMS](state, payload) {
    // console.log('UPDATE_MISSION_ALARMS', payload)

    for (let index = 0; index < payload.a.length; index++) {
      const element = payload.a[index]

      const missionIndex = state.missionAlarms.findIndex(item => item.name === element.n)
      if (missionIndex !== -1) {
        for (let index1 = 0; index1 < state.missionAlarms[missionIndex].vehicles.length; index1++) {
          const vehicle = state.missionAlarms[missionIndex].vehicles[index1]
          if (vehicle.alarmId === element.i) {
            state.missionAlarms[missionIndex].vehicles[index1].isJustified = payload.j
            state.missionAlarms[missionIndex].vehicles[index1].observations = payload.o
            break
          }
        }
        break
      }
    }
  },
  [types.SET_LOADING_MISSION_ALARMS](state, value) {
    state.loadingMissionAlarms = value
  },
  [types.FETCH_MISSION_ALARMS](state, data) {
    // console.log('NEW DATA!!! FETCH_MISSION_ALARMS')
    data.forEach(element => {
      const vehicles = element.vehicles
      const vehiclesUntilSort = vehicles.sort(function(a, b) {
        const textA = a.endTime
        const textB = b.endTime
        return (textA > textB) ? -1 : (textA < textB) ? 1 : 0
      })
      element.vehicles = vehiclesUntilSort
    })
    state.missionAlarms = data
  },
  [types.SET_LOADING_SPEED_ALARMS](state, value) {
    state.loadingSpeedAlarms = value
  },
  [types.FETCH_SPEED_ALARMS](state, data) {
    state.speedsAlarms = data
  },
  [types.SET_SHOW_AUTO_RELOAD_ALARM](state, value) {
    state.showAutoReloadAlarm = value
  },
  [types.SET_SHOW_RELOAD_ALARMS_MESSAGE](state, value) {
    state.showReloadAlarmsMessage = value
  },
  [types.SET_MISSION_ALERT_INTERVAL_INSTANCE](state, value) {
    state.missionAlertsIntervalInstance = value
  },
  [types.SET_CURRENT_JUSTIFICATIONS_IN_PROGRESS](state, payload) {
    if (payload.v) {
      state.currentJustificationsInProgress.push(payload)
    } else {
      const index = state.currentJustificationsInProgress.findIndex(item => item.i === payload.i)
      if (index !== -1) {
        state.currentJustificationsInProgress.splice(index, 1)
      }
    }
  },
  [types.SET_LOADING_PARKING_ALARMS](state, value) {
    state.loadingParkingAlarms = value
  },
  [types.FETCH_PARKING_ALARMS](state, data) {
    state.parkingAlarms = data
  },
  [types.UPDATE_PARKING_ALARMS](state, payload) {
    const alarmIndex = state.parkingAlarms.findIndex(item => item.alarmId === payload.i)
    if (alarmIndex !== -1) {
      state.parkingAlarms[alarmIndex].justification.isJustified = payload.j
      state.parkingAlarms[alarmIndex].justification.observations = payload.o
    }
  },
  [types.CLEAR_PARKING_ALARMS](state) {
    state.parkingAlarms = []
  },
  [types.SET_LOADING_GEOFENCE_IN_ALARMS](state, value) {
    state.loadingGeofenceInAlarms = value
  },
  [types.FETCH_GEOFENCE_IN_ALARMS](state, data) {
    // console.log('NEW DATA!!! FETCH_GEOFENCE_IN_ALARMS')
    data.forEach(element => {
      const vehicles = element.vehicles
      const vehiclesUntilSort = vehicles.sort(function(a, b) {
        const textA = a.endTime
        const textB = b.endTime
        return (textA > textB) ? -1 : (textA < textB) ? 1 : 0
      })
      element.vehicles = vehiclesUntilSort
    })
    state.geofenceInAlarms = data
  },
  [types.UPDATE_GEOFENCE_IN_EVENT_ALARMS](state, payload) {
    // console.log('UPDATE_GEOFENCE_IN_EVENT_ALARMS', state.geofenceInAlarms, payload)
    for (let index = 0; index < state.geofenceInAlarms.length; index++) {
      const element = state.geofenceInAlarms[index]
      const alarmIndex = element.vehicles.findIndex(item => item.alarmId === payload.i)
      if (alarmIndex !== -1) {
        state.geofenceInAlarms[index].vehicles[alarmIndex].isJustified = payload.j
        state.geofenceInAlarms[index].vehicles[alarmIndex].observations = payload.o
        break
      }
    }
  },
  [types.CLEAR_GEOFENCE_IN_ALARMS](state) {
    state.geofenceInAlarms = []
  },
  [types.SET_LOADING_VEHICLES_WITHOUT_EVENTS_3H_ALARMS](state, value) {
    state.loadingVehicleWithoutEvents3hAlarms = value
  },
  [types.FETCH_VEHICLES_WITHOUT_EVENTS_3H_ALARMS](state, data) {
    state.vehicleWithoutEvents3hAlarms = data
  },
  [types.CLEAR_VEHICLES_WITHOUT_EVENTS_3H_ALARMS](state) {
    state.vehicleWithoutEvents3hAlarms = []
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/alarms.js